<template>
  <div class="product-box__segment-header__wrapper">
    <div
      v-if="highlightArticleData"
      class="product-box__highlight-article-badge"
    >
      <div
        v-if="highlightArticleData.text"
        v-html="highlightArticleData.text"
        class="product-box__highlight-article-text"
      />
      <img
        v-if="highlightArticleData.icon"
        class="product-box__highlight-article-icon"
        :src="highlightArticleData.icon"
        alt=""
        width="20"
        height="20"
        aria-hidden="true"
      >
    </div>
    <component
      :is="personalizedBannerLink ? 'a' : 'div'"
      class="product-box__personalization-banner-wrapper"
      v-else-if="productBoxData.personalPreferenceMessageKey && !showReview"
      :href="personalizedBannerLink"
    >
      <div
        class="product-box__personalization-banner personalization-banner"
        v-html="t(productBoxData.personalPreferenceMessageKey)"
      />
    </component>
    <div class="product-box__segment-header">
      <component
        :is="productLink ? 'a' : 'div'"
        :href="productLink"
        class="product-box__header-text"
      >
        <span class="product-box__name">
          <span v-if="numberOfBottlesInSet">
            {{ numberOfBottlesInSet }} x
          </span>
          {{ productBoxData.name }}
        </span>
        <span
          class="product-box__short-description"
          v-if="productBoxData.shortDescription"
          v-html="productBoxData.shortDescription"
        />
      </component>

      <button
        v-if="!productBoxData.zeroPriceItem"
        class="product-box__button-wishlist"
        :class="{
          'product-box__button-wishlist--filled': isWishlistEnabled && productBoxData.inWishlist,
          'product-box__button-wishlist--remove': !isWishlistEnabled,
          'product-box__button-wishlist--loading': state === 'loadingWishlist',
        }"
        :aria-label="t('wishlist.default.name')"
        type="button"
        @click.prevent="emit('wishlistClicked')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import {computed} from 'vue';
  import type ProductBoxData from '../../../bps/types/ProductBoxData';
  import {t} from '../../../bps/utilities/js/translations/translations';
  import useHighlightArticle from '@/bps/utilities/composables/productHighlightArticle';

  const emit = defineEmits(['wishlistClicked']);

  const props = withDefaults(defineProps<{
    productBoxData: ProductBoxData;
    state: string;
    numberOfBottlesInSet?: number;
    productLink?: string;
    showReview?: boolean;
    showInBasket?: boolean;
    isWishlistEnabled?: boolean;
  }>(), {
    numberOfBottlesInSet: null,
    productLink: '',
    showReview: false,
    showInBasket: false,
    isWishlistEnabled: true
  });

  const personalizedBannerLink = computed(() => {
    return t(`productbox.link.${props.productBoxData.personalPreferenceMessageKey}`, [props.productBoxData.url]);
  });

  const {highlightArticleData} = useHighlightArticle(props.productBoxData.highlightArticleId);
</script>
